import { baseApiUrl } from "../environment/values";
import { axiosInstance as axios } from "../main";

const defaultState = () => {
  return {
    formData: {
      transactions: [],
      cbu: "",
      invoice: null,
      date: null,
      invoiceNumber: null,
      cuit: null,
      amount: null,
    },
    pendingTransactions: [],
    technicianAccounts: [],
    isLoading: false,
    isDetailLoading: false,
    invoices: [],
    bill: null,
    totalAmountToInvoice: null,
    showAlert: true,
    iva: null,
    isBillsLoading: false,
    validatedCUIT: null,
  };
};

const state = {
  formData: {
    transactions: [],
    cbu: "",
    invoice: null,
    date: null,
    invoiceNumber: null,
    cuit: null,
    amount: null,
  },
  pendingTransactions: [],
  technicianAccounts: [],
  isLoading: false,
  isDetailLoading: false,
  validationStatus: "idle",
  invoices: [],
  bill: null,
  totalAmountToInvoice: null,
  showAlert: true,
  iva: null,
  isBillsLoading: false,
  validatedCUIT: null
};

  const getters = {
    getBillById: (state) => (id) => {
      return state.invoices.find((invoice) => invoice.id === id);
    },
    formDataTransactions: (state) => {
      if (state.formData && state.formData.transactions)
        return state.formData.transactions;
      return [];
    },
    cbuAccountSelected: (state) => {
      return (
        state.technicianAccounts?.find(
          (account) => account.id === state.formData?.cbu
        ) ?? ""
      );
    },
    ivaCondition: (state) => {
      const ivaFromStorage = localStorage.getItem("iva");
      return ivaFromStorage ? Number(ivaFromStorage) : state.iva;
    },
  };

  const actions = {
    getBills({ commit }) {
      const url = `${baseApiUrl}invoice/`
      commit('setIsBillsLoading', true)
      axios.get(url)
        .then(({ data }) => {
          commit('setInvoices', data.invoice_list)
          commit('setIva', data.technician.condicion_iva)
          localStorage.setItem('iva', data.technician.condicion_iva)
        })
        .catch((error) => {
          console.log(error)
        }).finally(() => {
          commit('setIsBillsLoading', false)
        });
    },
    getTotalAmount({ commit, state }) {
      const url = `${baseApiUrl}pending_transactions/get_total_amount`

      axios
        .get(url)
        .then(({ data }) => {
          const totalAmount = data.total_amount;
          commit("setTotalAmountToInvoice", totalAmount);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getBillDetail({ commit, getters, state }, id) {
      commit("setIsDetailLoading", true);
      try {
        const url = `${baseApiUrl}invoice/${id}/`;
        const invoiceRes = await axios.get(url);
        const invoice = invoiceRes.data;
        commit("setBill", invoice);
        commit("setIsDetailLoading", false);
        return invoice;
      } catch (error) {
        throw error;
      } finally {
        commit("setIsDetailLoading", false);
      }
    },
    async getPendingTransactions({ commit, state }) {
      const url = `${baseApiUrl}pending_transactions/`;

      commit("setIsLoading", true);
      axios
        .get(url)
        .then(({ data }) => {
          commit("setPendingTransactions", data);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          commit("setIsLoading", false);
        });
    },
    async getTechnicianAccounts({ commit, state }) {
      const url = `${baseApiUrl}datos_facturacion/`;

      commit("setIsLoading", true);
      axios
        .get(url)
        .then(({ data }) => {
          commit("setTechnicianAccounts", data);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          commit("setIsLoading", false);
        });
    },
    async invoiceFileValidation({ commit, state }, formData) {
      if (!formData) return;
      commit("setValidationStatus", "loading");
      const url = `${baseApiUrl}invoice/pre_validation/`;
      try {
        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        const cuit = response.data.cuit;
        commit("setValidatedCUIT", cuit);
        commit("setValidationStatus", "success");
      } catch (error) {
        commit("setValidationStatus", "error");
        throw error;
      }
    },
    async sendInvoice(context, newInvoice) {
      const url = `${baseApiUrl}invoice/`;
      try {
        await axios.post(url, newInvoice, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } catch (error) {
        throw error;
      }
    },
    handleFormDataChanges({ commit, state, getters }, newData) {
      commit("setFormData", newData);
    },
    setInvoiceFile({ commit, state }, file) {
      const newInvoice = {
        ...state.formData,
        invoice: file,
      };
      commit("setFormData", newInvoice);
    },
    hideBillAlert({ commit }) {
      commit("setShowAlert", false);
    },
    async requestRevision(
      { commit, state },
      { transactionId, motivo, montoSugerido }
    ) {
      try {
        const url = `${baseApiUrl}pending_transactions/${transactionId}/request_for_review/`;
        const payload = {
          reason_review: motivo,
          suggested_amount: montoSugerido,
        };
        const response = await axios.post(url, payload);
        const updatedTransaction = response.data;

        const formTransactionIndex = state.formData.transactions.findIndex(
          (transaction) => transaction.id === updatedTransaction.id
        );
        const draft = { ...state.formData };
        if (formTransactionIndex !== -1) {
          draft.transactions.splice(formTransactionIndex, 1);
          commit("setFormData", draft);
        }
      } catch (error) {
        console.error("Error al solicitar revisión:", error);
        throw error;
      }
    },
  };

  const mutations = {
    setValidationStatus: (state, payload) => (state.validationStatus = payload),
    setValidatedCUIT: (state, payload) => (state.validatedCUIT = payload),
    setIva: (state, payload) => (state.iva = payload),
    setFormData: (state, payload) => (state.formData = payload),
    setIsLoading: (state, payload) => (state.isLoading = payload),
    setIsBillsLoading: (state, payload) => (state.isBillsLoading = payload),
    setPendingTransactions: (state, payload) => (state.pendingTransactions = payload),
    setTechnicianAccounts: (state, payload) => (state.technicianAccounts = payload),
    setInvoices: (state, payload) => (state.invoices = payload),
    setBill: (state, payload) => (state.bill = payload),
    setTotalAmountToInvoice: (state, payload) => (state.totalAmountToInvoice = payload),
    setShowAlert: (state, payload) => (state.showAlert = payload),
    setState: (state) => {
      Object.assign(state, defaultState())
    },
    setIsDetailLoading: (state, payload) => (state.isDetailLoading = payload),
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
